import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isLoggedIn = false;
  name = '';
  initials = '';
  role = '';

  constructor(private userService: UserService, private router: Router) {}

  ngOnInit(): void {
    this.userService.user$.subscribe((userData) => {
      this.isLoggedIn = !!userData;

      if (userData?.user) {
        this.name = userData.user.name ?? '';
        this.role = userData.user.role ?? '';
        this.initials = this.extractInitials(this.name);
      } else {
        this.name = '';
        this.initials = '';
      }
    });
  }

  extractInitials(name: string): string {
    if (!name) return '';
    const words = name.trim().split(/\s+/);
    return (words[0]?.[0] ?? '') + (words[1]?.[0] ?? '');
  }

  handleLogout(): void {
    this.userService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
  }
}
